import UseCase, { NoParams } from "../../core/useCase/UseCase";
import { SessionRepository } from "../repository/SessionRepository";

/** Records "the member did something just now" on the shared idle clock. */
export default class TouchSessionActivity extends UseCase<void, NoParams> {
  repository: SessionRepository;

  constructor(repository: SessionRepository) {
    super();
    this.repository = repository;
  }

  execute = () => this.repository.touchActivity();
}
